var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BrowsingService } from "../../../services/browsing.service";
import { LocalizationService } from "../../../services/localization.service";
import { EduComponent } from "../../../utils/eduComponent";
import ResourceUtils from "../../../utils/resource-utils";
var MainNavigation = /** @class */ (function (_super) {
    __extends(MainNavigation, _super);
    function MainNavigation(browsingService, localizationService, router) {
        var _this = _super.call(this) || this;
        _this.browsingService = browsingService;
        _this.localizationService = localizationService;
        _this.router = router;
        _this.gtmPrefix = "gtm-navigation-";
        _this.predefinedSubjectsList = ResourceUtils.predefinedSubjectsList;
        _this.isGradesPanelOpened = false;
        _this.isSubjectsPanelOpened = false;
        _this.stateName = null;
        return _this;
    }
    MainNavigation.prototype.matchSubjectColour = function (id, subjectsList) {
        return subjectsList.find(function (x) { return x.subjectID === id; }).colour;
    };
    MainNavigation.prototype.getAvailableSubjects = function (discipline) {
        return discipline.children.filter(function (node) { return node.resultsCount > 0; });
    };
    MainNavigation.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.browsingService.getSubjectsTree().subscribe(function (data) {
            _this.subjects = data;
        }, function (error) { return console.error("[CUSTOM Error]" + error); }));
        this.subscriptions.push(this.localizationService.localizeData.subscribe(function (response) {
            if (response && response.stateName) {
                _this.stateName = response.stateName;
            }
            else {
                _this.stateName = null;
            }
        }));
    };
    MainNavigation.prototype.toggleGradesPanel = function () {
        this.isGradesPanelOpened = !this.isGradesPanelOpened;
        this.isSubjectsPanelOpened = false;
        return;
    };
    MainNavigation.prototype.toggleSubjectsPanel = function () {
        this.isSubjectsPanelOpened = !this.isSubjectsPanelOpened;
        this.isGradesPanelOpened = false;
        return;
    };
    return MainNavigation;
}(EduComponent));
export { MainNavigation };
